//获取cookie、
export function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
}

//设置cookie,增加到vue实例方便全局调用
export function setCookie (c_name, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()+";path=/");
};

//删除cookie
export function delCookie (name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString()+"; path=/";
};
export function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return '';
}

export function getMonthShort(str){
  var monthStr = '';
  switch (str){
    case '01':
      monthStr = 'Jan';
      break;
    case '02':
      monthStr = 'Feb';
      break;
    case '03':
      monthStr = 'Mar';
      break;
    case '04':
      monthStr = 'Apr';
      break;
    case '05':
      monthStr = 'May';
      break;
    case '06':
      monthStr = 'Jun';
      break;
    case '07':
      monthStr = 'Jul';
      break;
    case '08':
      monthStr = 'Aug';
      break;
    case '09':
      monthStr = 'Sept';
      break;
    case '10':
      monthStr = 'Oct';
      break;
    case '11':
      monthStr = 'Nov';
      break;
    case '12':
      monthStr = 'Dec';
      break;
  }
  return monthStr;
}

export function isFunction(value) {
    return Object.prototype.toString.apply(value) === '[object Function]';
}








// WEBPACK FOOTER //
// ./src/util/util.js